import { Component, Input } from '@angular/core';
import { AdStatus } from '../../marketing-review-interfaces/marketing-review.interface';

/**
 * Status pill for a marketing advertisement. Used by the ads list, the dashboard and the review
 * page so the badge palette lives in one place.
 */
@Component({
    selector: 'app-ad-status-badge',
    imports: [],
    templateUrl: './ad-status-badge.component.html',
    styleUrl: './ad-status-badge.component.scss'
})
export class AdStatusBadgeComponent {

    @Input({ required: true }) status!: AdStatus;

    /** Kebab-case class hook, e.g. `In_Review` → `in-review`. */
    get statusClass(): string {
        return this.status.toLowerCase().replace(/_/g, '-');
    }

    /** Display label, e.g. `In_Review` → `In Review`. */
    get statusLabel(): string {
        return this.status.replace(/_/g, ' ');
    }
}
